import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Heart } from "lucide-react";
import { useContent } from "../context/ContentContext";

const Footer = () => {
  const { content } = useContent();
  const s = content?.settings || {};
  const handle = s.instagramHandle || "curiousgeorge27";
  return (
    <footer className="bg-navy text-offwhite" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-3 gap-12 items-start">
          <div>
            <h3 className="font-serif text-3xl mb-4">{s.coupleNames || "George & Amy"}</h3>
            <p className="text-offwhite/70 text-sm leading-relaxed max-w-xs">{s.footerText}</p>
          </div>
          <div className="flex flex-col gap-2">
            <span className="uppercase tracking-[0.2em] text-xs text-blush mb-2">Explore</span>
            <Link to="/details" className="text-offwhite/80 hover:text-blush transition-colors w-fit">Wedding Details</Link>
            <Link to="/journey" className="text-offwhite/80 hover:text-blush transition-colors w-fit">Our Journey</Link>
            <Link to="/family" className="text-offwhite/80 hover:text-blush transition-colors w-fit">Our Family</Link>
            <Link to="/rsvp" className="text-offwhite/80 hover:text-blush transition-colors w-fit">RSVP</Link>
          </div>
          <div className="flex flex-col gap-3">
            <span className="uppercase tracking-[0.2em] text-xs text-blush mb-1">Follow Along</span>
            <a
              href={`https://instagram.com/${handle}`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-offwhite/80 hover:text-blush transition-colors w-fit"
              data-testid="footer-instagram"
            >
              <Instagram size={18} /> @{handle}
            </a>
            <span className="text-offwhite/60 text-sm">{s.hashtag}</span>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-offwhite/50">
          <span className="inline-flex items-center gap-1.5">Made with <Heart size={12} className="text-blush fill-blush" /> for our celebration</span>
          <Link to="/admin" className="hover:text-offwhite/80 transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
